import $ from 'jquery'

export default class {
    constructor(params) {
        this.settings = {...this.defaults(), ...params}
        $(this.settings.targetSelector).each((idx, element) => {
            this.addTargetObj(element)
            let obj = $(element).find('input[type="hidden"]')
            if (obj.val()) {
                obj.siblings('.preview').show();
            }
        })
    }
    defaults() {
        return {
            targetSelector: '.item.image',
            uploadPath: '/api/file/upload', // 通常アップロード
            uploadUrlPath: '/api/file/uploadUrl', // ファイルurlを指定してのアップロード
            uploadKeyName: 'file',
            deleteAjax: false,
            deletePath: '/api/file/del',
            deleteSelector: '.del',
            typeFilter: [],
            fileSizeLimit: null,
            uploadDir: '/',
            ajaxSetup: {},
            ajaxAddData: null,
            appendHeaders: {},
        }
    }

    addTargetObj(element) {
        let fileObj = $(element).find('input[type="file"]')
        fileObj.on('click.fileUpload', event => {
            event.currentTarget.value = ''
        })
        fileObj.on('change.fileUpload', event => {
            this.loadLocalFile(element, event)
        })
        $(element).find(this.settings.deleteSelector).on('click', event => {
            let path = $(element).find('input[type="hidden"]').val()
            this.delete(path)
                .then(resp => {
                    this.deletedFile(element, resp)
                })
        })
    }

    loadLocalFile(element, event) {
        const targetObj = event.currentTarget;
        // ファイル情報を取得
        const fileData = event.target.files[0];

        // フィルター処理
        let matches = this.settings.typeFilter.filter(val => {
            if (fileData.type.match(val)) {
                return true;
            }
        });
        if (matches.length === 0) {
            alert('指定されたファイルタイプは選択できません')
            return;
        }

        // ファイルサイズ制限
        if (fileData.size > this.settings.fileSizeLimit * 1048576) { // 1024 * 1024
            alert(`${this.settings.fileSizeLimit}MB以内のファイルを選択してください。`)
            return;
        }

        // FileReaderオブジェクトを使ってファイル読み込み
        const reader = new FileReader();

        // ファイル読み込みに成功したときの処理
        reader.onload = () => {
            this.loadedFile(element, reader, fileData)
            this.upload(targetObj)
                .then(resp => {
                    this.uploadedFile(element, resp, fileData)
                })
                .catch(resp => {
                    console.log(resp)
                    this.error(element, resp)
                })
        }
        // ファイル読み込みを実行
        reader.readAsDataURL(fileData);
    }
    loadUrl(url, renderObj) {
        this.uploadUrl(url)
            .then(resp => {
                this.uploadedFile(renderObj, resp)
            })
            .catch(error => {
                console.log(error)
                this.error(renderObj, error)
            })
    }

    // アップロードレスポンスを検証し、異常な場合はサーバのerrorオブジェクト(無ければError)をthrowする
    async checkUploadResponse(resp) {
        let data = null
        try {
            data = await resp.json()
        } catch (e) {
            data = null
        }
        // サーバがerrorオブジェクトを返している場合はそのまま渡し、error()側でdescriptionを表示させる
        if (data && data.error) {
            throw data.error
        }
        if (!resp.ok) {
            throw new Error(`upload failed: ${resp.status}`)
        }
        // 画像アップロードは{file: {...}}形式で返るため、実データ部分を見て判定する
        const file = (data && data.file) ? data.file : data
        if (!file || !('name' in file) || !('key' in file)) {
            throw new Error('upload failed: invalid response')
        }
        return data
    }

    async upload(obj) {
        const fd = new FormData();
        fd.append(this.settings.uploadKeyName, $(obj).prop("files")[0])
        if (this.settings.ajaxAddData) {
            Object.keys(this.settings.ajaxAddData).forEach(_key => {
                fd.append(_key, this.settings.ajaxAddData[_key])
            })
        }
        fd.append('uploadDir', this.settings.uploadDir)
        const params = {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                ...this.settings.appendHeaders,
            },
            body: fd,
            ...this.settings.ajaxSetup
        }

        return await fetch(this.settings.uploadPath, params)
        .then(resp => {
            return this.checkUploadResponse(resp)
        })
    }
    async uploadUrl(url) {
        const fd = new FormData();
        fd.append('url', url)
        fd.append('uploadDir', this.settings.uploadDir)

        let params = {
            method: 'POST',
            credentials: 'same-origin',
            body: fd,
        }
        Object.assign(params, this.settings.ajaxSetup)

        let resp = await fetch(this.settings.uploadUrlPath, params)
        return this.checkUploadResponse(resp)
    }

    delete(path) {
        return new Promise((resolve, reject) => {
            if (this.settings.deleteAjax) {
                let ajaxData = { path }
                let ajaxParams = Object.assign({
                    url: this.settings.deletePath,
                    type: 'post',
                    dataType: 'json',
                    data: ajaxData,
                }, this.settings.ajaxSetup)
                $.ajax(ajaxParams)
                    .done(function (res) {
                        resolve(res)
                    })
                    .fail(function (jqXHR, statusText, errorThrown) {
                        reject(errorThrown)
                    });
            } else {
                resolve()
            }
        })
    }

    loadedFile(element, reader) {
        return null
    }
    uploadedFile(element, resp) {
        return null
    }
    deletedFile(element, resp) {
        return null
    }
    error(element, params = null) {
        alert('アップロードエラー')
    }
}
